import React from "react";
import { useNavigate } from "react-router-dom";
import { SlArrowRight, SlArrowLeft } from "../utils/Icons";

const NavigationTracker = ({ endpoint = "" }) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Large Screens */}
      <div className="w-full h-fit hidden lg:flex justify-start items-center space-x-[0.5%] mb-[1%]">
        <button
          className="font-normal text-[1vw] text-textSecondaryColor hover:underline"
          onClick={() => navigate("/")}
        >
          Home
        </button>
        <SlArrowRight className="font-normal text-[0.75vw] text-textSecondaryColor" />
        <span className="font-medium text-[1vw] text-textSecondaryColor">
          {endpoint}
        </span>
      </div>

      {/* Small Screens */}
      {/* <div className="w-full h-fit flex justify-start items-center space-x-[2%] mb-[5%] lg:hidden">
        <SlArrowLeft className="font-normal text-[3.5vw] text-textSecondaryColor" />
        <button
          className="font-normal text-[4vw] text-textSecondaryColor hover:underline"
          onClick={() => navigate("/")}
        >
          Back
        </button>
      </div> */}
    </>
  );
};

export default NavigationTracker;
